import { dayjs } from '@shared/utils';

import { UserStatus, TwoFAStatus } from '../../../constants';
import { type User, type UserResponse } from '../../../types';

function mapStatus(status: string | null, invitationExpireAt: string | null) {
  if (status === null) {
    throw new Error('Status is required');
  }
  if (status === 'INVITATION_PENDING' && dayjs(invitationExpireAt).isBefore(dayjs())) {
    return UserStatus.INVITATION_EXPIRED;
  }
  return status as UserStatus;
}

const VALID_TWO_FA_STATUSES = new Set<string>(Object.values(TwoFAStatus));

function mapTwoFAStatus(status: string | null): TwoFAStatus {
  if (status !== null && VALID_TWO_FA_STATUSES.has(status)) {
    return status as TwoFAStatus;
  }
  return TwoFAStatus.UNLINKED;
}

export function mapper(user: UserResponse): User {
  return {
    id: user.id,
    firstName: user.firstname ?? '', // NOTE: This should not be null
    lastName: user.lastname ?? '', // NOTE: This should not be null
    email: user.email ?? '', // NOTE: This should not be null
    status: mapStatus(user.status, user.invitationExpireAt),
    appRoles: user.appRoles ?? [],
    createdAt: user.createdAt,
    lastLoginAt: user.lastLoginAt,
    invitationExpireAt: user.invitationExpireAt,
    twoFactorStatus: mapTwoFAStatus(user.twoFactorStatus),
  };
}
